import { createDependencyAttribute, updateDependencyAttribute, deleteDependencyAttribute } from '../../../../API/dependencies';

// Crear un nuevo atributo de dependencia
export const handleAddNewAttribute = (editedAttributes, setEditedAttributes) => {
  setEditedAttributes([...editedAttributes, { key: '', isUpdated: false, isNew: true  }]);
};

// Cambiar un atributo de dependencia
export const handleAttributeChange = (index, value, editedAttributes, setEditedAttributes) => {
  const updatedAttributes = [...editedAttributes];
  updatedAttributes[index].key = value;
  updatedAttributes[index].isUpdated = true; // Marca que fue modificado
  setEditedAttributes(updatedAttributes);
};

// Eliminar un atributo de dependencia localmente
export const handleDeleteLocalAttribute = (index, editedAttributes, setEditedAttributes) => {
  const updatedAttributes = editedAttributes.filter((_, i) => i !== index);
  setEditedAttributes(updatedAttributes);
};

// Eliminar un atributo de dependencia desde el backend
export const handleDeleteAttribute = (index, editedAttributes, setEditedAttributes, deletedAttributes, setDeletedAttributes, api) => {
  const attribute = editedAttributes[index];

  // Eliminar localmente
  handleDeleteLocalAttribute(index, editedAttributes, setEditedAttributes);

  if (attribute.id) {
    // Si tiene id, agregar a la lista de eliminados
    setDeletedAttributes([...deletedAttributes, attribute.id]);
  } else {
    //api.warning({ message: "Este atributo de dependencia no tiene id, no se puede eliminar desde el backend." });
  }
};

// Guardar atributos de dependencia (POST, PUT, DELETE)
export const handleSaveAttributes = async (editedAttributes, deletedAttributes, onClose, api) => {
  let hasChanges = false; // Indicador de cambios

  // Nuevos atributos (POST)
  const newAttributes = editedAttributes.filter(attribute => !attribute.id); 
  for (const attribute of newAttributes) {
    try {
      await createDependencyAttribute({ key: attribute.key });
      hasChanges = true;
    } catch (error) {
      api.error({ 
        message: "Error al guardar el atributo de dependencia",
        description: error?.response?.data?.name?.[0],
        key: 'save-attribute-error'
      });
      return;
    }
  }

  // Atributos modificados (PUT)
  const updatedAttributes = editedAttributes.filter(attribute => attribute.id && attribute.isUpdated);
  for (const attribute of updatedAttributes) {
    try {
      await updateDependencyAttribute(attribute.id, { key: attribute.key });
      hasChanges = true;
    } catch (error) {
      api.error({ message: "Error al actualizar el atributo de dependencia" });
      return;
    }
  }

  // Eliminar atributos (DELETE)
  for (const deletedAttributeId of deletedAttributes) {
    try {
      await deleteDependencyAttribute(deletedAttributeId);
      hasChanges = true;
    } catch (error) {
      api.error({ message: "Error al eliminar el atributo de dependencia" });
      return;
    }
  }

  // Solo cierra si hubo cambios
  if (hasChanges) {
    api.success({ message: 'Atributos de dependencia guardados correctamente' });
    onClose();
  } else {
    api.info({ 
      message: "No hay cambios para guardar",
      key: 'save-attribute-info'
    });
  }
};